import { InvokeCallback, Sender } from "xstate";
import { withToken } from "@rentablo/api";
import { AccountTypeEnum, createAccount } from "@rentablo/api/apiv1";
import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";
import { investmentTypeToAccountType } from "../utils/utils";

export const persistDepot =
  (
    context: TransactionWizardContext,
    event: TransactionWizardEvent
  ): InvokeCallback<TransactionWizardEvent, TransactionWizardEvent> =>
  (callback) => {
    if (event.type !== "PERSIST_DEPOT")
      throw new Error(`Invalid event type: ${event.type}`);
    if (!context.investmentValues.type)
      throw new Error("Investment type is not defined");

    const type = investmentTypeToAccountType(context.investmentValues.type);
    persist(callback, event.name, type, event.currency);
  };

const persist = async (
  callback: Sender<TransactionWizardEvent>,
  name: string,
  type: AccountTypeEnum,
  currency?: string
) => {
  const createDepotAccount = withToken(createAccount);
  try {
    const account = await createDepotAccount({
      createOrUpdateAccountParams: {
        name: name,
        type: type,
        currency: currency,
        enableImplicitTransactions: true,
      },
    });
    callback({
      type: "DEPOT_PERSISTED",
      depotId: account.id,
      currency: currency,
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
